<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz produkt, który chcesz opisać:</label>

              <b-input-group>

                <b-form-input v-model="produkt" size="lg" ref="produkt" placeholder="np. mikrofon bezprzewodowy marki Shure, donica ogrodowa, rower górski marki xyz."></b-form-input>
                
              </b-input-group>
 
            </div>

            
            <div class="mt-3">

              <label>Opisz lub wklej specyfikację produktu:</label>

              <b-input-group>

                <b-form-input v-model="specyfikacja" size="lg" ref="specyfikacja" placeholder="np. donica wazy 3 kilogramy, jest wykonana z gliny, kolor biały itd."></b-form-input>
                
              </b-input-group>

            </div>

            
            <div class="mt-3">

              <label>Opisz w kilku słowach kto jest idealnym klientem:</label>

              <b-input-group>

                <b-form-input v-model="klient" size="lg" ref="klient" placeholder="np. poczatkująca osoba na siłowni, w wieku 30 lat, która dopiero zaczyna przygodę z siłownią."></b-form-input>
                
              </b-input-group>

            </div>

            <b-form-group class="mt-3" label="Wybierz schemat copywriterski:" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  id="radio-group-1"
                  v-model="schemat"
                  :options="schematy"
                  :aria-describedby="ariaDescribedby"
                  name="schemat"
                  stacked
              ></b-form-radio-group>
            </b-form-group>

            <br/>

            <b-form-checkbox v-model="addEmoji" value="true">Dodaj emoji</b-form-checkbox>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj opis
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje opis <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowany opis</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: 'App12XSellingMachineAI',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        selectedText: '',
        query: "",
        produkt: "",
        specyfikacja: "",
        klient: "",
        schemat: "[Nagłówek, wprowadzenie, specyfikacja techniczna, korzyści, Q&A, CTA]",
        schematy: [
          {
            text: "Silny nagłówek - korzyści",
            value: "[Nagłówek, wprowadzenie, specyfikacja techniczna, korzyści, Q&A, CTA]"
          },
          {
            text: "David Ogilvy",
            value: "[Nagłówek w stylu Davida Ogilvy, wprowadzenie z słowami niesamowity, niezwykły itd. specyfikacja techniczna, jakie 3 problemy rozwiązuje produkt, zwięźle opisane 5 korzyści i krótkie CTA.]"
          },
          {
            text: "Silne korzyści",
            value: "[Silny nagłówek rozpoczęty pytaniem, wprowadzenie w schemacie problem – rozwiązanie, 5 korzyści z odniesieniem do zmysłów klienta i krótkie CTA]"
          },
          {
            text: "AIDA",
            value: "[Styl AIDA schemat Przykucie uwagi, zainteresowanie, wzbudzenie pożądania i silne wezwanie do akcji.]"
          },
          {
            text: "Problem – Rozwiązanie",
            value: "[Styl problem rozwiązanie. Opisz problem, który rozwiązuje produkt, następnie pokaż, że produkt rozwiązuje ten problem na końcu przekonaj do zakupu używają 3 technik perswazji, zakończ silnym, krótkim CTA.]"
          },
          {
            text: "FAB",
            value: "[Schemat FAB Schemat wymień cechy produktu i zamień je na korzyści, następnie podaj 3 powody dla których ludzie wybierają te produkty i zakończ krótkim wezwaniem do akcji w stylu kup teraz.]"
          },
          {
            text: "Storytelling",
            value: "[Schemat sprzedawanie przez opowiedzenie historii. Zacznij od nagłówka copywriterskiego z pytaniem, następnie napisz krótką historię o tym jak produkt rozwiązał problem klienta/klientki. Na końcu wypisz 5 korzyści ze stosowania tego produktu. Zakończ wezwaniem do akcji.]"
          },
          {
            text: "Social Proof",
            value: "[Nagłówek w stylu Davida Ogilvy, wprowadzenie z słowami niesamowity, niezwykły itd. specyfikacja techniczna, technika dowodu społecznego np. jak dużo osób korzysta, jak popularny jest to produkt następnie jakie 3 problemy rozwiązuje produkt, zwięźle opisane 5 korzyści i krótkie CTA]"
          },
          {
            text: "Porównanie produktu",
            value: "[Porównaj produkt z innymi opcjami na rynku, pokaż przewagę twojego produktu, wypisz 3 rzeczy, które doceniają klienci, napisz silne wezwanie do akcji.]"
          },
          {
            text: "How To",
            value: "[zacznij od kreatywnego nagłówka w stylu mistrzów reklamy następnie opisz jak stosować produkt, następnie wypisz 5 powodów dla których warto kupić ten produkt zakończ wezwaniem do akcji.]"
          },
          {
            text: "Kreatywny Copywriter",
            value: "[Napisz bardzo kreatywny tekst reklamowy nie używaj tendencyjnych zwrotów typu nasz produkt. Napisz w stylu kreatywnego copywritera, baw się słowem na końcu napisz najbardziej oryginalne wezwanie do akcji.]"
          }
        ],
        addEmoji: false,
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {
  
      generateFinish: function() {

        if(!this.produkt) return false;
        if(!this.specyfikacja) return false;
        if(!this.klient) return false;
        if(!this.schemat) return false;

        
        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "Napisz skuteczny opis produktu do sklepu internetowego. Ten produkt to " + this.produkt + " oto jego specyfikacja techniczna " + this.specyfikacja + ". Opis kierujemy do " + this.klient + ". Napisz opis według schematu reklamowego " + this.schemat + ". Ważne! Nie pisz tekstu jak wszyscy. Zrób to w sposób mniej konwencjonalny i zastosuj kreatywność. Nie pisz elementów schematu, pisz jednolitym tekstem.";

        if(this.addEmoji) {

          query = query + "Dodaj emoji."

        }

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana kampania"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

      this.$watch('finishContent', (value) => {

        var lines = value.split(/\r|\r\n|\n/);

        this.finishLinesCount = lines.length;

      })
 
    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>